<template>
  <div class="file-downloader_box">
    <p class="bold_label">{{documentUrl.name}}</p>
    <a class="active-rectangle_button" :href="documentUrl.url">ダウンロード</a>
  </div>
</template>

<script>
  export default {
    name: "FileDownloaderBox",

    props: {
      documentUrl: {
        type: Object,
        required: true
      }
    },

  }
</script>


<style lang="scss" scoped>
  .file-downloader_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
  }
</style>